import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Header = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-99">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <header className="mb-8" data-id="element-100">
      {/* Top banner button */}
      <div className="mb-6" data-id="element-101"></div>

      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-blue-800 leading-tight" data-id="element-102">
        Onderzoek: Straffen maakt honden 3 keer agressiever
      </h1>
      <div className="text-center mb-4 text-blue-600 font-semibold" data-id="element-103">
        3.897 honden onderzocht en de resultaten zijn schokkend, Amee legt uit
        waarom - tijdens haar webinar Communiceren Met Je Hond
      </div>
      <div className="w-full mb-6" data-id="element-104">
        <a href="https://stresslessdogs.nl/mcc-gpm-adv1" target="_blank" rel="noopener noreferrer" data-id="element-105">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vK5yBdTaFAnzK4LEcjoEMH/freepik__candid-photography-with-natural-textures-and-highl__57096_%281%29.png" alt="Jack Russell terrier die agressief gedrag vertoont aan de lijn" className="w-full h-auto rounded-lg shadow-md cursor-pointer" data-id="element-106" />
        </a>
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-107">
          "Honden die gestraft worden, zijn 3 keer vaker agressief"
        </p>
      </div>
      <div className="w-full h-[1px] bg-gray-200 my-6" data-id="element-108"></div>
    </header>;
};